// extracted by mini-css-extract-plugin
export default {"page":"RefundPolicy_page__TCBuk","content":"RefundPolicy_content__c9e13","header":"RefundPolicy_header__vkYeo","box":"RefundPolicy_box__9qWii"};